/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedGodModeRouteImport } from './routes/_protected/_god-mode'
import { Route as ProtectedOrganizationIdRouteImport } from './routes/_protected/$organizationId'
import { Route as AuthUpdatePasswordRouteImport } from './routes/_auth/update-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as ProtectedOrganizationIdIndexRouteImport } from './routes/_protected/$organizationId/index'
import { Route as ProtectedOrganizationIdFlowIdRouteImport } from './routes/_protected/$organizationId/$flowId'
import { Route as ProtectedGodModeGodModeIndexRouteImport } from './routes/_protected/_god-mode/god-mode/index'
import { Route as ProtectedOrganizationIdFlowIdIndexRouteImport } from './routes/_protected/$organizationId/$flowId/index'
import { Route as ProtectedGodModeGodModeFlowsRouteImport } from './routes/_protected/_god-mode/god-mode/flows'
import { Route as ProtectedGodModeGodModeOrgIdRouteImport } from './routes/_protected/_god-mode/god-mode/$orgId'
import { Route as ProtectedOrganizationIdFlowIdSettingsRouteImport } from './routes/_protected/$organizationId/$flowId/settings'
import { Route as ProtectedOrganizationIdFlowIdSessionsRouteImport } from './routes/_protected/$organizationId/$flowId/sessions'
import { Route as ProtectedOrganizationIdFlowIdSettingsIndexRouteImport } from './routes/_protected/$organizationId/$flowId/settings/index'
import { Route as ProtectedOrganizationIdFlowIdSessionsIndexRouteImport } from './routes/_protected/$organizationId/$flowId/sessions/index'
import { Route as ProtectedOrganizationIdFlowIdSettingsProviderRouteImport } from './routes/_protected/$organizationId/$flowId/settings/provider'
import { Route as ProtectedOrganizationIdFlowIdSettingsApiKeysRouteImport } from './routes/_protected/$organizationId/$flowId/settings/api-keys'
import { Route as ProtectedOrganizationIdFlowIdSessionsReadinessRouteImport } from './routes/_protected/$organizationId/$flowId/sessions/readiness'
import { Route as ProtectedOrganizationIdFlowIdSessionsSessionIdRouteImport } from './routes/_protected/$organizationId/$flowId/sessions/$sessionId'

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedGodModeRoute = ProtectedGodModeRouteImport.update({
  id: '/_god-mode',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedOrganizationIdRoute = ProtectedOrganizationIdRouteImport.update({
  id: '/$organizationId',
  path: '/$organizationId',
  getParentRoute: () => ProtectedRoute,
} as any)
const AuthUpdatePasswordRoute = AuthUpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedOrganizationIdIndexRoute =
  ProtectedOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationIdRoute,
  } as any)
const ProtectedOrganizationIdFlowIdRoute =
  ProtectedOrganizationIdFlowIdRouteImport.update({
    id: '/$flowId',
    path: '/$flowId',
    getParentRoute: () => ProtectedOrganizationIdRoute,
  } as any)
const ProtectedGodModeGodModeIndexRoute =
  ProtectedGodModeGodModeIndexRouteImport.update({
    id: '/god-mode/',
    path: '/god-mode/',
    getParentRoute: () => ProtectedGodModeRoute,
  } as any)
const ProtectedOrganizationIdFlowIdIndexRoute =
  ProtectedOrganizationIdFlowIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationIdFlowIdRoute,
  } as any)
const ProtectedGodModeGodModeFlowsRoute =
  ProtectedGodModeGodModeFlowsRouteImport.update({
    id: '/god-mode/flows',
    path: '/god-mode/flows',
    getParentRoute: () => ProtectedGodModeRoute,
  } as any)
const ProtectedGodModeGodModeOrgIdRoute =
  ProtectedGodModeGodModeOrgIdRouteImport.update({
    id: '/god-mode/$orgId',
    path: '/god-mode/$orgId',
    getParentRoute: () => ProtectedGodModeRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSettingsRoute =
  ProtectedOrganizationIdFlowIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProtectedOrganizationIdFlowIdRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSessionsRoute =
  ProtectedOrganizationIdFlowIdSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => ProtectedOrganizationIdFlowIdRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSettingsIndexRoute =
  ProtectedOrganizationIdFlowIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSettingsRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSessionsIndexRoute =
  ProtectedOrganizationIdFlowIdSessionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSessionsRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSettingsProviderRoute =
  ProtectedOrganizationIdFlowIdSettingsProviderRouteImport.update({
    id: '/provider',
    path: '/provider',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSettingsRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSettingsApiKeysRoute =
  ProtectedOrganizationIdFlowIdSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSettingsRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSessionsReadinessRoute =
  ProtectedOrganizationIdFlowIdSessionsReadinessRouteImport.update({
    id: '/readiness',
    path: '/readiness',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSessionsRoute,
  } as any)
const ProtectedOrganizationIdFlowIdSessionsSessionIdRoute =
  ProtectedOrganizationIdFlowIdSessionsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => ProtectedOrganizationIdFlowIdSessionsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/$organizationId': typeof ProtectedOrganizationIdRouteWithChildren
  '/$organizationId/$flowId': typeof ProtectedOrganizationIdFlowIdRouteWithChildren
  '/$organizationId/': typeof ProtectedOrganizationIdIndexRoute
  '/$organizationId/$flowId/sessions': typeof ProtectedOrganizationIdFlowIdSessionsRouteWithChildren
  '/$organizationId/$flowId/settings': typeof ProtectedOrganizationIdFlowIdSettingsRouteWithChildren
  '/god-mode/$orgId': typeof ProtectedGodModeGodModeOrgIdRoute
  '/god-mode/flows': typeof ProtectedGodModeGodModeFlowsRoute
  '/$organizationId/$flowId/': typeof ProtectedOrganizationIdFlowIdIndexRoute
  '/god-mode/': typeof ProtectedGodModeGodModeIndexRoute
  '/$organizationId/$flowId/sessions/$sessionId': typeof ProtectedOrganizationIdFlowIdSessionsSessionIdRoute
  '/$organizationId/$flowId/sessions/readiness': typeof ProtectedOrganizationIdFlowIdSessionsReadinessRoute
  '/$organizationId/$flowId/settings/api-keys': typeof ProtectedOrganizationIdFlowIdSettingsApiKeysRoute
  '/$organizationId/$flowId/settings/provider': typeof ProtectedOrganizationIdFlowIdSettingsProviderRoute
  '/$organizationId/$flowId/sessions/': typeof ProtectedOrganizationIdFlowIdSessionsIndexRoute
  '/$organizationId/$flowId/settings/': typeof ProtectedOrganizationIdFlowIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ProtectedIndexRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/$organizationId': typeof ProtectedOrganizationIdIndexRoute
  '/god-mode/$orgId': typeof ProtectedGodModeGodModeOrgIdRoute
  '/god-mode/flows': typeof ProtectedGodModeGodModeFlowsRoute
  '/$organizationId/$flowId': typeof ProtectedOrganizationIdFlowIdIndexRoute
  '/god-mode': typeof ProtectedGodModeGodModeIndexRoute
  '/$organizationId/$flowId/sessions/$sessionId': typeof ProtectedOrganizationIdFlowIdSessionsSessionIdRoute
  '/$organizationId/$flowId/sessions/readiness': typeof ProtectedOrganizationIdFlowIdSessionsReadinessRoute
  '/$organizationId/$flowId/settings/api-keys': typeof ProtectedOrganizationIdFlowIdSettingsApiKeysRoute
  '/$organizationId/$flowId/settings/provider': typeof ProtectedOrganizationIdFlowIdSettingsProviderRoute
  '/$organizationId/$flowId/sessions': typeof ProtectedOrganizationIdFlowIdSessionsIndexRoute
  '/$organizationId/$flowId/settings': typeof ProtectedOrganizationIdFlowIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/update-password': typeof AuthUpdatePasswordRoute
  '/_protected/$organizationId': typeof ProtectedOrganizationIdRouteWithChildren
  '/_protected/_god-mode': typeof ProtectedGodModeRouteWithChildren
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/$organizationId/$flowId': typeof ProtectedOrganizationIdFlowIdRouteWithChildren
  '/_protected/$organizationId/': typeof ProtectedOrganizationIdIndexRoute
  '/_protected/$organizationId/$flowId/sessions': typeof ProtectedOrganizationIdFlowIdSessionsRouteWithChildren
  '/_protected/$organizationId/$flowId/settings': typeof ProtectedOrganizationIdFlowIdSettingsRouteWithChildren
  '/_protected/_god-mode/god-mode/$orgId': typeof ProtectedGodModeGodModeOrgIdRoute
  '/_protected/_god-mode/god-mode/flows': typeof ProtectedGodModeGodModeFlowsRoute
  '/_protected/$organizationId/$flowId/': typeof ProtectedOrganizationIdFlowIdIndexRoute
  '/_protected/_god-mode/god-mode/': typeof ProtectedGodModeGodModeIndexRoute
  '/_protected/$organizationId/$flowId/sessions/$sessionId': typeof ProtectedOrganizationIdFlowIdSessionsSessionIdRoute
  '/_protected/$organizationId/$flowId/sessions/readiness': typeof ProtectedOrganizationIdFlowIdSessionsReadinessRoute
  '/_protected/$organizationId/$flowId/settings/api-keys': typeof ProtectedOrganizationIdFlowIdSettingsApiKeysRoute
  '/_protected/$organizationId/$flowId/settings/provider': typeof ProtectedOrganizationIdFlowIdSettingsProviderRoute
  '/_protected/$organizationId/$flowId/sessions/': typeof ProtectedOrganizationIdFlowIdSessionsIndexRoute
  '/_protected/$organizationId/$flowId/settings/': typeof ProtectedOrganizationIdFlowIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/update-password'
    | '/$organizationId'
    | '/$organizationId/$flowId'
    | '/$organizationId/'
    | '/$organizationId/$flowId/sessions'
    | '/$organizationId/$flowId/settings'
    | '/god-mode/$orgId'
    | '/god-mode/flows'
    | '/$organizationId/$flowId/'
    | '/god-mode/'
    | '/$organizationId/$flowId/sessions/$sessionId'
    | '/$organizationId/$flowId/sessions/readiness'
    | '/$organizationId/$flowId/settings/api-keys'
    | '/$organizationId/$flowId/settings/provider'
    | '/$organizationId/$flowId/sessions/'
    | '/$organizationId/$flowId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reset-password'
    | '/update-password'
    | '/$organizationId'
    | '/god-mode/$orgId'
    | '/god-mode/flows'
    | '/$organizationId/$flowId'
    | '/god-mode'
    | '/$organizationId/$flowId/sessions/$sessionId'
    | '/$organizationId/$flowId/sessions/readiness'
    | '/$organizationId/$flowId/settings/api-keys'
    | '/$organizationId/$flowId/settings/provider'
    | '/$organizationId/$flowId/sessions'
    | '/$organizationId/$flowId/settings'
  id:
    | '__root__'
    | '/_auth'
    | '/_protected'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/update-password'
    | '/_protected/$organizationId'
    | '/_protected/_god-mode'
    | '/_protected/'
    | '/_protected/$organizationId/$flowId'
    | '/_protected/$organizationId/'
    | '/_protected/$organizationId/$flowId/sessions'
    | '/_protected/$organizationId/$flowId/settings'
    | '/_protected/_god-mode/god-mode/$orgId'
    | '/_protected/_god-mode/god-mode/flows'
    | '/_protected/$organizationId/$flowId/'
    | '/_protected/_god-mode/god-mode/'
    | '/_protected/$organizationId/$flowId/sessions/$sessionId'
    | '/_protected/$organizationId/$flowId/sessions/readiness'
    | '/_protected/$organizationId/$flowId/settings/api-keys'
    | '/_protected/$organizationId/$flowId/settings/provider'
    | '/_protected/$organizationId/$flowId/sessions/'
    | '/_protected/$organizationId/$flowId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_god-mode': {
      id: '/_protected/_god-mode'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedGodModeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$organizationId': {
      id: '/_protected/$organizationId'
      path: '/$organizationId'
      fullPath: '/$organizationId'
      preLoaderRoute: typeof ProtectedOrganizationIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_auth/update-password': {
      id: '/_auth/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/$organizationId/': {
      id: '/_protected/$organizationId/'
      path: '/'
      fullPath: '/$organizationId/'
      preLoaderRoute: typeof ProtectedOrganizationIdIndexRouteImport
      parentRoute: typeof ProtectedOrganizationIdRoute
    }
    '/_protected/$organizationId/$flowId': {
      id: '/_protected/$organizationId/$flowId'
      path: '/$flowId'
      fullPath: '/$organizationId/$flowId'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdRouteImport
      parentRoute: typeof ProtectedOrganizationIdRoute
    }
    '/_protected/_god-mode/god-mode/': {
      id: '/_protected/_god-mode/god-mode/'
      path: '/god-mode'
      fullPath: '/god-mode/'
      preLoaderRoute: typeof ProtectedGodModeGodModeIndexRouteImport
      parentRoute: typeof ProtectedGodModeRoute
    }
    '/_protected/$organizationId/$flowId/': {
      id: '/_protected/$organizationId/$flowId/'
      path: '/'
      fullPath: '/$organizationId/$flowId/'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdIndexRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdRoute
    }
    '/_protected/_god-mode/god-mode/flows': {
      id: '/_protected/_god-mode/god-mode/flows'
      path: '/god-mode/flows'
      fullPath: '/god-mode/flows'
      preLoaderRoute: typeof ProtectedGodModeGodModeFlowsRouteImport
      parentRoute: typeof ProtectedGodModeRoute
    }
    '/_protected/_god-mode/god-mode/$orgId': {
      id: '/_protected/_god-mode/god-mode/$orgId'
      path: '/god-mode/$orgId'
      fullPath: '/god-mode/$orgId'
      preLoaderRoute: typeof ProtectedGodModeGodModeOrgIdRouteImport
      parentRoute: typeof ProtectedGodModeRoute
    }
    '/_protected/$organizationId/$flowId/settings': {
      id: '/_protected/$organizationId/$flowId/settings'
      path: '/settings'
      fullPath: '/$organizationId/$flowId/settings'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSettingsRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdRoute
    }
    '/_protected/$organizationId/$flowId/sessions': {
      id: '/_protected/$organizationId/$flowId/sessions'
      path: '/sessions'
      fullPath: '/$organizationId/$flowId/sessions'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSessionsRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdRoute
    }
    '/_protected/$organizationId/$flowId/settings/': {
      id: '/_protected/$organizationId/$flowId/settings/'
      path: '/'
      fullPath: '/$organizationId/$flowId/settings/'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSettingsIndexRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSettingsRoute
    }
    '/_protected/$organizationId/$flowId/sessions/': {
      id: '/_protected/$organizationId/$flowId/sessions/'
      path: '/'
      fullPath: '/$organizationId/$flowId/sessions/'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSessionsIndexRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSessionsRoute
    }
    '/_protected/$organizationId/$flowId/settings/provider': {
      id: '/_protected/$organizationId/$flowId/settings/provider'
      path: '/provider'
      fullPath: '/$organizationId/$flowId/settings/provider'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSettingsProviderRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSettingsRoute
    }
    '/_protected/$organizationId/$flowId/settings/api-keys': {
      id: '/_protected/$organizationId/$flowId/settings/api-keys'
      path: '/api-keys'
      fullPath: '/$organizationId/$flowId/settings/api-keys'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSettingsApiKeysRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSettingsRoute
    }
    '/_protected/$organizationId/$flowId/sessions/readiness': {
      id: '/_protected/$organizationId/$flowId/sessions/readiness'
      path: '/readiness'
      fullPath: '/$organizationId/$flowId/sessions/readiness'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSessionsReadinessRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSessionsRoute
    }
    '/_protected/$organizationId/$flowId/sessions/$sessionId': {
      id: '/_protected/$organizationId/$flowId/sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/$organizationId/$flowId/sessions/$sessionId'
      preLoaderRoute: typeof ProtectedOrganizationIdFlowIdSessionsSessionIdRouteImport
      parentRoute: typeof ProtectedOrganizationIdFlowIdSessionsRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ProtectedOrganizationIdFlowIdSessionsRouteChildren {
  ProtectedOrganizationIdFlowIdSessionsSessionIdRoute: typeof ProtectedOrganizationIdFlowIdSessionsSessionIdRoute
  ProtectedOrganizationIdFlowIdSessionsReadinessRoute: typeof ProtectedOrganizationIdFlowIdSessionsReadinessRoute
  ProtectedOrganizationIdFlowIdSessionsIndexRoute: typeof ProtectedOrganizationIdFlowIdSessionsIndexRoute
}

const ProtectedOrganizationIdFlowIdSessionsRouteChildren: ProtectedOrganizationIdFlowIdSessionsRouteChildren =
  {
    ProtectedOrganizationIdFlowIdSessionsSessionIdRoute:
      ProtectedOrganizationIdFlowIdSessionsSessionIdRoute,
    ProtectedOrganizationIdFlowIdSessionsReadinessRoute:
      ProtectedOrganizationIdFlowIdSessionsReadinessRoute,
    ProtectedOrganizationIdFlowIdSessionsIndexRoute:
      ProtectedOrganizationIdFlowIdSessionsIndexRoute,
  }

const ProtectedOrganizationIdFlowIdSessionsRouteWithChildren =
  ProtectedOrganizationIdFlowIdSessionsRoute._addFileChildren(
    ProtectedOrganizationIdFlowIdSessionsRouteChildren,
  )

interface ProtectedOrganizationIdFlowIdSettingsRouteChildren {
  ProtectedOrganizationIdFlowIdSettingsApiKeysRoute: typeof ProtectedOrganizationIdFlowIdSettingsApiKeysRoute
  ProtectedOrganizationIdFlowIdSettingsProviderRoute: typeof ProtectedOrganizationIdFlowIdSettingsProviderRoute
  ProtectedOrganizationIdFlowIdSettingsIndexRoute: typeof ProtectedOrganizationIdFlowIdSettingsIndexRoute
}

const ProtectedOrganizationIdFlowIdSettingsRouteChildren: ProtectedOrganizationIdFlowIdSettingsRouteChildren =
  {
    ProtectedOrganizationIdFlowIdSettingsApiKeysRoute:
      ProtectedOrganizationIdFlowIdSettingsApiKeysRoute,
    ProtectedOrganizationIdFlowIdSettingsProviderRoute:
      ProtectedOrganizationIdFlowIdSettingsProviderRoute,
    ProtectedOrganizationIdFlowIdSettingsIndexRoute:
      ProtectedOrganizationIdFlowIdSettingsIndexRoute,
  }

const ProtectedOrganizationIdFlowIdSettingsRouteWithChildren =
  ProtectedOrganizationIdFlowIdSettingsRoute._addFileChildren(
    ProtectedOrganizationIdFlowIdSettingsRouteChildren,
  )

interface ProtectedOrganizationIdFlowIdRouteChildren {
  ProtectedOrganizationIdFlowIdSessionsRoute: typeof ProtectedOrganizationIdFlowIdSessionsRouteWithChildren
  ProtectedOrganizationIdFlowIdSettingsRoute: typeof ProtectedOrganizationIdFlowIdSettingsRouteWithChildren
  ProtectedOrganizationIdFlowIdIndexRoute: typeof ProtectedOrganizationIdFlowIdIndexRoute
}

const ProtectedOrganizationIdFlowIdRouteChildren: ProtectedOrganizationIdFlowIdRouteChildren =
  {
    ProtectedOrganizationIdFlowIdSessionsRoute:
      ProtectedOrganizationIdFlowIdSessionsRouteWithChildren,
    ProtectedOrganizationIdFlowIdSettingsRoute:
      ProtectedOrganizationIdFlowIdSettingsRouteWithChildren,
    ProtectedOrganizationIdFlowIdIndexRoute:
      ProtectedOrganizationIdFlowIdIndexRoute,
  }

const ProtectedOrganizationIdFlowIdRouteWithChildren =
  ProtectedOrganizationIdFlowIdRoute._addFileChildren(
    ProtectedOrganizationIdFlowIdRouteChildren,
  )

interface ProtectedOrganizationIdRouteChildren {
  ProtectedOrganizationIdFlowIdRoute: typeof ProtectedOrganizationIdFlowIdRouteWithChildren
  ProtectedOrganizationIdIndexRoute: typeof ProtectedOrganizationIdIndexRoute
}

const ProtectedOrganizationIdRouteChildren: ProtectedOrganizationIdRouteChildren =
  {
    ProtectedOrganizationIdFlowIdRoute:
      ProtectedOrganizationIdFlowIdRouteWithChildren,
    ProtectedOrganizationIdIndexRoute: ProtectedOrganizationIdIndexRoute,
  }

const ProtectedOrganizationIdRouteWithChildren =
  ProtectedOrganizationIdRoute._addFileChildren(
    ProtectedOrganizationIdRouteChildren,
  )

interface ProtectedGodModeRouteChildren {
  ProtectedGodModeGodModeOrgIdRoute: typeof ProtectedGodModeGodModeOrgIdRoute
  ProtectedGodModeGodModeFlowsRoute: typeof ProtectedGodModeGodModeFlowsRoute
  ProtectedGodModeGodModeIndexRoute: typeof ProtectedGodModeGodModeIndexRoute
}

const ProtectedGodModeRouteChildren: ProtectedGodModeRouteChildren = {
  ProtectedGodModeGodModeOrgIdRoute: ProtectedGodModeGodModeOrgIdRoute,
  ProtectedGodModeGodModeFlowsRoute: ProtectedGodModeGodModeFlowsRoute,
  ProtectedGodModeGodModeIndexRoute: ProtectedGodModeGodModeIndexRoute,
}

const ProtectedGodModeRouteWithChildren =
  ProtectedGodModeRoute._addFileChildren(ProtectedGodModeRouteChildren)

interface ProtectedRouteChildren {
  ProtectedOrganizationIdRoute: typeof ProtectedOrganizationIdRouteWithChildren
  ProtectedGodModeRoute: typeof ProtectedGodModeRouteWithChildren
  ProtectedIndexRoute: typeof ProtectedIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedOrganizationIdRoute: ProtectedOrganizationIdRouteWithChildren,
  ProtectedGodModeRoute: ProtectedGodModeRouteWithChildren,
  ProtectedIndexRoute: ProtectedIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
